module.exports = __webpack_public_path__ + "img/01.3973cf0e.png";